import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

import { ReactComponent as CloseCircle } from '../../assets/icons/close-circle.svg';

interface ModalBoxProperties {
  title: string | null;
  content: JSX.Element | null;
  closeModal: () => void;
  open: boolean;
  header: boolean;
  rightCorner?: boolean;
  modalBoxAnimation?: 'modalAnimateToTop' | 'modalAnimateToLeft';
  notification?: boolean;
}

/**
 * Common modal box
 */
function ModalBox({
  title,
  content,
  closeModal,
  open,
  header,
  rightCorner,
  modalBoxAnimation,
  notification,
}: ModalBoxProperties) {
  const reference = useRef<HTMLDivElement>(null);
  /**
   * Close modal onClick outside
   */
  const handleClickOutside = (event: React.MouseEvent) => {
    if (reference.current === event.target && !notification) {
      closeModal();
    }
  };

  return open
    ? ReactDOM.createPortal(
        <div
          className={`modal-box-wrap ${open && 'open'} ${rightCorner && 'right-top'}`}
          onClick={handleClickOutside}
          role="presentation"
          ref={reference}>
          <div
            style={
              {
                '--modal-animation': modalBoxAnimation,
              } as React.CSSProperties
            }
            className="modal-box-container">
            {header && (
              <div className="modal-box-header">
                <div className="modal-box-title">
                  <span>{title}</span>
                </div>
                {!notification && (
                  <div className="modal-box-icon" onClick={closeModal} role="presentation">
                    <CloseCircle />
                  </div>
                )}
              </div>
            )}
            <div className="modal-box-body">
              {!header && !notification && (
                <div className="modal-box-icon" onClick={closeModal} role="presentation">
                  <CloseCircle />
                </div>
              )}
              {content}
            </div>
          </div>
        </div>,
        document.body,
      )
    : null;
}

ModalBox.defaultProps = {
  rightCorner: false,
  modalBoxAnimation: 'modalAnimateToTop',
  notification: false,
};

export default ModalBox;
